import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'

import { VueReCaptcha } from 'vue-recaptcha-v3'
import VueSocketIO from 'vue-socket.io'
import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'

// 3rd party plugins
import '@axios'
import '@/libs/acl'
import '@/libs/portal-vue'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@/libs/vue-select'
import '@/libs/firebase'

// Sử dụng VueSocketIO với kết nối đã thiết lập
Vue.use(new VueSocketIO({
  connection: process.env.VUE_APP_WEBSOCKET_URL,
}))

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Composition API
Vue.use(VueCompositionAPI)

// Vue recaptcha
Vue.use(VueReCaptcha, {
  siteKey: process.env.VUE_APP_GG_RECAPTCHA_KEY,
  loaderOptions: {
    autoHideBadge: true,
  },
})

// Vue.use(Schedule)
// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
